import React, { Component } from 'react';

class NewsPager extends Component {
  render() {
    const buttonStyles = {
      border: "none",
      margin: 0,
      padding: 0,
      width: "auto",
      overflow: "visible",
      background: "transparent",
      font: "inherit",
      lineHeight: "normal",
      borderBottom: "1px dashed"
    }
  
    return (
      <nav aria-label="Pagination Navigation"><ul style={{ textAlign:"center",margin:0,padding:0 }}>
        {this.props.back?<li style={{ display:"inline", listStyle: "none", paddingRight: "2em",margin:0}}><button className="hover" style={buttonStyles} onClick={this.props.prevPage}>&lt; Previous Page</button></li>:null}
        <li style={{display:"inline",listStyle:"none",margin:0}}><button className="hover" style={buttonStyles} onClick={this.props.nextPage}>Next Page &gt;</button></li>
      </ul></nav>
    );
  }
}

export default NewsPager;
